const initialState = { error: null, checkout: { step: 0, products: [], subtotal: 0, total: 0, discount: 0, shipping: 0, billing: null, payment: { type: 'free', method: 'card', card: '' } } };
export default function cart(state = initialState) {
  return state;
}
